import { render, staticRenderFns } from "./VisualKeymap.vue?vue&type=template&id=2282b1b4&"
import script from "./VisualKeymap.vue?vue&type=script&lang=js&"
export * from "./VisualKeymap.vue?vue&type=script&lang=js&"
import style0 from "./VisualKeymap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports